import React from 'react';

import { ICONS } from '../../../icons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

function Id8Header() {
  return <ProjectNameHeader icon={ICONS.Scout} defaultName='ID8' selector={(state) => state.id8?.projectName} />;
}

export default Id8Header;
